<template>
  <div class="spinner">
    <img src="@/assets/img/loading-red.svg" />
    <div class="text">loading..</div>
  </div>
</template>

<script>
export default {
  name: 'SpinnerBottom',
}
</script>

<style scoped>
.spinner {
  bottom: 160px;
  width: 100%;
  text-align: center;
  margin: auto;
  background-color: transparent;
}

.spinner > img {
  width: 32px;
  height: 32px;
  object-fit: contain;
  animation-name: spin;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  filter: grayscale(1);
}

.text {
  font-size: 12px;
  color: #9b9b9b;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
